import { mapGetters, mapActions } from "vuex";
import { throttle as _throttle } from "lodash";
import { debounce as _debounce } from "lodash";
export default {
  name: "Landing",
  data() {
    return {
      timeout: null,
      prevTouch: { x: 0, y: 0 },
      navigated: false,
      transition: "none",
    };
  },
  mounted() {
    if (!this.isWheelListenerInitialized) {
      document.addEventListener(
        "wheel",
        _throttle(this.onMouseWheel, 500, {
          leading: true,
          trailing: false,
        })
      );

      document.addEventListener("wheel", _debounce(this.stoppedScrolling, 100));
      this.setWheelListener(true);
    }
  },

  computed: {
    externalLinks() {
      return this.$t("headerAndMenu").items.filter(
        (x) => x.linkType === "external"
      );
    },

    ...mapGetters({
      isWheelListenerInitialized: "scroller/isWheelListenerInitialized",
      landingIndex: "scroller/landingIndex",
      mainSourcesRegistry: "ui/mainSourcesRegistry",
      isMenuOpen: "ui/isMenuOpen",
      isModalOpen: "ui/isModalOpen",
    }),
  },

  methods: {
    sourceClick(key) {
      this.setMainSource(key);
      this.$router.push("/" + key);
    },
    onSwipeStart(e) {
      if (e.touches && e.touches.length > 0) {
        const touch = e.touches[0];
        this.navigated = false;
        this.prevTouch.x = touch.clientX;
        this.prevTouch.y = touch.clientY;
      }
    },
    onSwipe(e) {
      if (
        e.touches &&
        e.touches.length > 0 &&
        !this.navigated &&
        !this.menuOpen
      ) {
        const touch = e.touches[0];

        // This condition is to only fire navigation when swiping up and down, not left to right
        // Otherwise there will be a conflict with swiping on the slider
        if (
          (this.prevTouch.y - touch.clientY > 5 ||
            this.prevTouch.y - touch.clientY < -5) &&
          this.prevTouch.x - touch.clientX < 5 &&
          this.prevTouch.x - touch.clientX > -5
        ) {
          this.navigateLanding(this.prevTouch.y, touch.clientY);
          this.navigated = true;
        }
      }
    },
    navigateLanding(eventY, compareValue) {
      //[NB] isMenuOpen directly requested from store otherwise it will be always false because of how computed propery works
      if (
        this.$store.getters["ui/isMenuOpen"] === false &&
        this.isModalOpen === false &&
        this.$route.name === "landing"
      ) {
        if (eventY > compareValue) {
          this.increment();
        } else if (eventY < compareValue && this.landingIndex > -1) {
          this.decrement();
        }
      }
    },
    stoppedScrolling() {
      this.navigated = false;
    },
    onMouseWheel(e) {
      if (!this.navigated) {
        this.navigated = true;
        this.navigateLanding(e.deltaY, 0);
      }
    },

    async waitAndResetTransition() {
      await new Promise((r) => setTimeout(r, 100));
      this.transition = "fade";
    },
    ...mapActions({
      setMainSource: "ui/setMainSource",
      increment: "scroller/increment",
      decrement: "scroller/decrement",
      setWheelListener: "scroller/setWheelListener",
    }),
  },
  watch: {
    landingIndex(newV, oldV) {
      if (newV > oldV) {
        this.transition = "rtl";
      } else {
        this.transition = "ltr";
      }

      // reset transition class after a while
      this.waitAndResetTransition();
    },
    isMenuOpen(newV) {
      if (newV) {
        this.transition = "ltr";
      } else {
        if (!this.isModalOpen) {
          this.transition = "rtl";
        } else {
          this.transition = "fade";
        }
      }
      // reset transition class after a while
      this.waitAndResetTransition();
    },
    isModalOpen() {
      this.transition = "fade";
    },
  },
};
